exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.button[data-v-ad91a4fc]{width:100%}.spinner[data-v-ad91a4fc]{margin-right:10px}input[data-v-ad91a4fc]::-webkit-inner-spin-button,input[data-v-ad91a4fc]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-ad91a4fc]{-moz-appearance:textfield}", ""]);

// exports
